import AvailableAndBookedSlotsComponent from "@components/routes/auth_routes/SlotsScreen/AvailableAndBookedSlotsComponent";

const CheckAvailableSlotsComponent = () => {
  return (
    <div className="px-4 py-4 bg-white mt-4 rounded-md">
      <AvailableAndBookedSlotsComponent />
    </div>
  );
};
export default CheckAvailableSlotsComponent;
